import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { unitOptions } from '../utils'

import Toggle from './Toggle'

export default class UnitToggle extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOf(['metric', 'imperial']).isRequired,
  }

  render() {
    const { onChange, value } = this.props

    return (
      <div className='calculation-group hidden-laptop hidden-desktop hidden-print'>
        Select your preferred unit of measurement

        <Toggle
          onChange={onChange}
          options={unitOptions['metric-imperial']}
          value={value}
        />
      </div>
    )
  }
}
